import { Component, OnInit, Inject,ViewChild ,ElementRef} from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ContactService } from '../../contact.service';
declare var jsPDF : any;
declare var html2canvas :any;
import * as moment from 'moment';



@Component({
  selector: 'app-normal-cert',
  templateUrl: './normal-cert.component.html',
  styleUrls: ['./normal-cert.component.scss']
})
export class NormalCertComponent implements OnInit {
  @ViewChild('content') content : ElementRef;
  certificateImgage: any;
  customerName: string;
  address: any;
  device_name: any;
  engineno: any;
  chessisno: any;
  imei: any;
  sim_number: any;
  fromDate: any;
  todate: any;
  imgurl: any;
  validity: any;
  constructor(public dialogRef: MdDialogRef<NormalCertComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,private contactService: ContactService) {
      console.log(data);
      var devObject = data.deviceInfo;
   
     if(devObject.user){
       var fName =devObject.user?devObject.user.first_name:"";
       var lName = devObject.user?devObject.user.last_name:"";
       console.log(fName+ lName)
       this.customerName =fName + " " + lName  }
       this.address = devObject.user?devObject.user.address:"NA";
       this.device_name ="VEHICLE NO" + " :"+"  " +(devObject.Device_Name?devObject.Device_Name:"NA");
       this.engineno ="ENGINE NO" + " :"+"  " + (devObject.engineNo?devObject.engineNo:"NA");
       this.chessisno = "CHESSIS NO" + " :"+"  " +  (devObject.ChassisNo? devObject.ChassisNo:"NA");
       this.imei ="DEVICE IMEI" + " :"+"  " + (devObject.Device_ID?devObject.Device_ID:"NA");
       this.sim_number ="DEVICE SIM NO" + " :"+"  " + devObject.sim_number?devObject.sim_number:"NA";
       if(devObject.created_on){   
         var created_time = new Date(devObject.created_on);
         this.fromDate= moment(created_time).format('DD-MM-YYYY');


       }else{
        this.fromDate = 'NA';
       }
       if(devObject.expiration_date){
        
         var e_time = new Date(devObject.expiration_date);
         this.todate =    moment(e_time).format('DD-MM-YYYY');

       }else{
        this.todate ="NA"
       }

       this.validity =  "VELIDITY OF DEVICE" + ":"+" " + this.fromDate + " " + 'TO' + " " + this.todate;
       

     }

  ngOnInit() {
    var that = this ;
    this.imgurl= '../../assets/image/f2_logo.png';
  this.toDataURL(this.imgurl, function(dataUrl) {
  console.log('RESULT:', dataUrl)
  that.convertedImage = dataUrl ; 
})
  }

  download(){
    var that = this;
    var doc = new jsPDF();
   
    var specialElementHandlers = {
      '#editor': function (element: any, renderer: any) {
        return true;
      }
    };

    doc.autoTable({
      theme: 'plain',
      html: '#testPdf', 
      margin:{left:25,right:25},
      styles :  {
        cellWidth : 50
      }, 
         
      willDrawCell: data => {
        if(data.row.index === 0){ 
          data.row.height = 25;             
          // data.row.cells[0].styles.lineHeight= "30";
          // doc.setLineHeightFactor()   
          doc.addImage(that.convertedImage,'JPEG',25, 10,25,15);
        }  

        doc.text(28, 200, 'DEALER STAMP & SEAL');
        doc.text(100, 200, 'CUSTOMER SIGNATURE');

        if((data.row.index === 1)){
          // data.row.cells[0].styles.halign = 'right';
          data.row.height = 15;             
        }
        
        if((data.row.index === 7)){
      
          // data.row.cells[0].styles.halign = 'right';
      
         
          // data.row.height = 95;            
        }
        if((data.row.index===1)||(data.row.index===4)||(data.row.index===5)){
          doc.setFontStyle('bold');    
        }
        // if(data.row.index === 1){ 
        //   data.row.height = 50;   
        //   console.log('data.row.cells',data.row.cells)   ;
        //   data.row.cells[0].styles.halign = 'center';
        //   // data.row.cells[0].styles.fontSize = 11; 
        //   doc.setFontStyle('bold');        
        // }  
        // if(data.row.index === 1){ 
        //   data.row.height = 50;      
        //   data.row.cells.styles.halign = 'center';
        // }  

 
   
      }
      
    });
    doc.save('Device_Cert.pdf');

  }
  convertedImage(convertedImage: any, arg1: string, arg2: number, arg3: number, arg4: number, arg5: number) {
    throw new Error("Method not implemented.");
  }


  


  cancel(){
    this.dialogRef.close('cancel');
  }


  toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

}




// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/device/normal-cert/normal-cert.component.ts